var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", [
    _c("label", [_vm._v("\n        " + _vm._s(_vm.fieldLabel) + "\n    ")]),
    _vm._v(" "),
    _c("div", { staticClass: "input-container" }, [
      _c("input", {
        attrs: {
          type: "text",
          "placeholder":// prettier-ignore
                _vm.t('cookbook', 'Enter URL or select from your Nextcloud instance on the right'),
        },
        domProps: { value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: {
            type: "button",
            title: _vm.t("cookbook", "Pick a local image"),
          },
          on: { click: _vm.pickImage },
        },
        [_c("span", { staticClass: "icon-category-multimedia" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }